import { FlexComp, FormattedText, ImageComponent, SpanTag } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { theme } from "@tm/utility/global";

import { OrderDetailCompStyle, PlanDetailStyle } from "./OrderDetailComp.style";
import { OrderDetailProp } from "./type";

const OrderDetailPlan = ({
  title,
  orderDetailIcon,
  planBenefits,
  handleMoreBenefits,
  ctaLink,
  subTitle,
  benefitsCTA,
}: OrderDetailProp) => {
  const device = useBreakpointV2();

  return (
    <div>
      <OrderDetailCompStyle>
        <FlexComp
          alignItems="center"
          margin={device == "lg" ? "0 0 8px" : "0 0 0"}
          gap="8px"
        >
          {orderDetailIcon && (
            <ImageComponent width="24px" height="24px" src={orderDetailIcon} />
          )}
          {title && (
            <SpanTag
              fontSize={device == "lg" ? "large" : "sm"}
              fontWeight="bold"
              color={theme.greyText}
            >
              <FormattedText value={title} />
            </SpanTag>
          )}
        </FlexComp>
        <PlanDetailStyle>
          <SpanTag
            fontSize={device == "lg" ? "large" : "sm"}
            fontWeight="bold"
            color={theme.greyText}
          >
            <FormattedText value={subTitle} />
          </SpanTag>
        </PlanDetailStyle>
      </OrderDetailCompStyle>
      {/* {device == 'sm' && (
                <OrderMobCtaWrap>
                    <AnchorTag
                        handleClick={handleMoreBenefits}
                        fontWeight="bold"
                    >
                        <FormattedText value="View all 15 benefits" />
                    </AnchorTag>
                    <ImageComponent
                        width="16px"
                        height="16px"
                        src="https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg"
                    />
                </OrderMobCtaWrap>
            )} */}
    </div>
  );
};

export default OrderDetailPlan;
